import { render } from "./Sales.vue?vue&type=template&id=5b60a349&scoped=true&ts=true"
import script from "./Sales.vue?vue&type=script&lang=ts"
export * from "./Sales.vue?vue&type=script&lang=ts"

import "./Sales.vue?vue&type=style&index=0&id=5b60a349&scoped=true&lang=scss"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b60a349"]])

export default __exports__